module.exports = __webpack_public_path__ + "img/qr.d05796e3.png";